import React, { useState } from 'react';
import { APP_CHANGELOG } from '../data/changelog';
import PortalOverlay from './common/PortalOverlay';

function ChangelogModal({ isOpen, onClose }) {
  const [selectedVersion, setSelectedVersion] = useState(APP_CHANGELOG[0]);

  if (!isOpen) return null;

  return (
    <PortalOverlay isOpen={isOpen} onClose={onClose}>
    <div
      data-testid="changelog-modal"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.8)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10000,
        padding: '20px'
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: 'linear-gradient(135deg, rgba(13,27,42,0.98) 0%, rgba(27,38,59,0.98) 100%)',
          borderRadius: '20px',
          maxWidth: '900px',
          width: '100%',
          maxHeight: '85vh',
          overflow: 'hidden',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.7), 0 0 100px rgba(212, 175, 55, 0.2)',
          border: '2px solid rgba(212, 175, 55, 0.3)',
          display: 'flex',
          flexDirection: 'column'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header - MR JERRY Style */}
        <div style={{
          padding: '28px 36px',
          background: 'linear-gradient(135deg, #d4af37 0%, #f4d03f 50%, #d4af37 100%)',
          borderBottom: '2px solid rgba(212, 175, 55, 0.5)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          {/* Animated background effect */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'radial-gradient(circle at 30% 50%, rgba(255,255,255,0.2) 0%, transparent 60%)',
            animation: 'shimmer 4s ease-in-out infinite',
            pointerEvents: 'none'
          }} />
          
          <div style={{ position: 'relative', zIndex: 1 }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              marginBottom: '6px'
            }}>
              <span style={{ 
                fontSize: '32px',
                filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.4))',
                animation: 'float 3s ease-in-out infinite'
              }}>📰</span>
              <h2 style={{ 
                margin: 0, 
                fontSize: '32px', 
                fontWeight: '800', 
                color: '#1a1a1a',
                textShadow: '0 2px 10px rgba(0,0,0,0.3)',
                letterSpacing: '-0.5px'
              }}>
                Nowości w aplikacji
              </h2>
            </div>
            <p style={{ 
              margin: '0', 
              color: 'rgba(26, 26, 26, 0.8)', 
              fontSize: '15px',
              fontWeight: '600',
              textShadow: '0 1px 3px rgba(255,255,255,0.3)'
            }}>
              ✨ Historia aktualizacji MR JERRY
            </p>
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'rgba(26, 26, 26, 0.25)',
              border: 'none',
              borderRadius: '10px',
              width: '42px',
              height: '42px',
              cursor: 'pointer',
              fontSize: '22px',
              color: '#1a1a1a',
              transition: 'all 0.2s',
              position: 'relative',
              zIndex: 1,
              fontWeight: 'bold',
              boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = 'rgba(26, 26, 26, 0.35)';
              e.target.style.transform = 'rotate(90deg) scale(1.1)';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'rgba(26, 26, 26, 0.25)';
              e.target.style.transform = 'rotate(0deg) scale(1)';
            }}
          >
            ✕
          </button>
        </div>

        <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
          {/* Sidebar - Version List - MR JERRY Style */}
          <div style={{
            width: '250px',
            borderRight: '2px solid rgba(212, 175, 55, 0.2)',
            overflowY: 'auto',
            background: 'rgba(0, 0, 0, 0.4)'
          }}>
            {APP_CHANGELOG.map((version) => (
              <div
                key={version.version}
                onClick={() => setSelectedVersion(version)}
                style={{
                  padding: '16px 20px',
                  cursor: 'pointer',
                  borderLeft: selectedVersion.version === version.version ? '4px solid #d4af37' : '4px solid transparent',
                  background: selectedVersion.version === version.version ? 'rgba(212, 175, 55, 0.2)' : 'transparent',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  if (selectedVersion.version !== version.version) {
                    e.currentTarget.style.background = 'rgba(212, 175, 55, 0.1)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (selectedVersion.version !== version.version) {
                    e.currentTarget.style.background = 'transparent';
                  }
                }}
              >
                <div style={{ fontWeight: 'bold', color: '#d4af37', fontSize: '16px', marginBottom: '4px' }}>
                  {version.version}
                </div>
                <div style={{ fontSize: '12px', color: 'rgba(255, 255, 255, 0.6)' }}>
                  {version.date}
                </div>
                {version.version === APP_CHANGELOG[0].version && (
                  <span style={{
                    display: 'inline-block',
                    marginTop: '6px',
                    padding: '3px 10px',
                    background: 'linear-gradient(135deg, #d4af37 0%, #f4d03f 100%)',
                    color: '#1a1a1a',
                    fontSize: '10px',
                    borderRadius: '6px',
                    fontWeight: 'bold',
                    boxShadow: '0 2px 6px rgba(212, 175, 55, 0.4)'
                  }}>
                    NAJNOWSZA
                  </span>
                )}
              </div>
            ))}
          </div>

          {/* Content - Version Details - MR JERRY Style */}
          <div style={{
            flex: 1,
            overflowY: 'auto',
            padding: '32px'
          }}>
            <div style={{ marginBottom: '24px' }}>
              <h3 style={{
                margin: '0 0 8px 0',
                fontSize: '24px',
                fontWeight: 'bold',
                color: '#d4af37'
              }}>
                {selectedVersion.title}
              </h3>
              <div style={{
                display: 'flex',
                gap: '12px',
                alignItems: 'center',
                fontSize: '14px',
                color: 'rgba(255, 255, 255, 0.7)'
              }}>
                <span style={{
                  padding: '4px 12px',
                  background: 'linear-gradient(135deg, rgba(212, 175, 55, 0.3) 0%, rgba(244, 208, 63, 0.2) 100%)',
                  borderRadius: '6px',
                  fontWeight: '600',
                  color: '#d4af37',
                  border: '1px solid rgba(212, 175, 55, 0.4)'
                }}>
                  {selectedVersion.version}
                </span>
                <span>📅 {selectedVersion.date}</span>
              </div>
            </div>

            {/* Features */}
            {selectedVersion.features && selectedVersion.features.map((feature, idx) => (
              <div key={idx} style={{
                marginBottom: '24px',
                padding: '20px',
                background: 'rgba(212, 175, 55, 0.08)',
                borderRadius: '12px',
                border: '1px solid rgba(212, 175, 55, 0.2)'
              }}>
                <h4 style={{
                  margin: '0 0 12px 0',
                  fontSize: '18px',
                  fontWeight: 'bold',
                  color: '#f4d03f'
                }}>
                  {feature.category}
                </h4>
                <ul style={{
                  margin: 0,
                  paddingLeft: '20px',
                  color: 'rgba(255, 255, 255, 0.9)',
                  lineHeight: '1.8'
                }}>
                  {feature.items.map((item, i) => (
                    <li key={i} style={{ marginBottom: '6px' }}>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}

            {/* Improvements - MR JERRY Style */}
            {selectedVersion.improvements && selectedVersion.improvements.length > 0 && (
              <div style={{
                marginTop: '20px',
                padding: '20px',
                background: 'rgba(212, 175, 55, 0.12)',
                borderRadius: '12px',
                border: '1px solid rgba(212, 175, 55, 0.3)',
                boxShadow: '0 2px 8px rgba(212, 175, 55, 0.1)'
              }}>
                <h4 style={{
                  margin: '0 0 12px 0',
                  fontSize: '18px',
                  fontWeight: 'bold',
                  color: '#d4af37'
                }}>
                  ✨ Ulepszenia
                </h4>
                <ul style={{
                  margin: 0,
                  paddingLeft: '20px',
                  color: 'rgba(255, 255, 255, 0.9)',
                  lineHeight: '1.8'
                }}>
                  {selectedVersion.improvements.map((item, i) => (
                    <li key={i} style={{ marginBottom: '6px' }}>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* CSS Animations */}
      <style>{`
        @keyframes shimmer {
          0%, 100% {
            opacity: 0.5;
            transform: translateX(-100%);
          }
          50% {
            opacity: 1;
            transform: translateX(100%);
          }
        }
        
        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-8px);
          }
        }
      `}</style>
    </div>
    </PortalOverlay>
  );
}

export default ChangelogModal;
